<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="Appendix"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        伯乐奖执行办法
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">“伯乐奖”推荐细则</h4>
                    <p>1. 泡泡少儿部</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）成功入职，奖金500元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）成功通过3个月试用期且代课符合部门针对新教师的要求，奖金1000元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（3）正常工作满一年且代课量符合泡泡少儿部平均代课水平，奖金3000元。</span>
                    <p>2. 优能中学部</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）成功入职，奖金500元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）成功代课一个季度，奖金1000元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（3）完成两个季度的带班及续报，奖金3000元。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">“伯乐奖”推荐细则</h4>
                    <p>3. 优能一对一部</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）成功入职，奖金200元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）成功通过3个月试用期且代课符合部门针对新教师的要求，奖金300元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（3）工作满一年且代课量符合一对一部平均代课水平，奖金1000元。</span>
                    <p>4. 国外考试部</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）成功入职，奖金500元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）成功通过3个月试用期且代课符合部门针对新教师的要求，奖金1000元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（3）正常工作满一年且代课量符合国外部平均代课水平，奖金5000元。</span>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">“伯乐奖”推荐细则</h4>
                    <p>5. 国内考试部</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）成功入职，奖金200元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）成功通过3个月试用期且代课符合部门针对新教师的要求，奖金300元；</span>
                    <span class="spanClass labourParticulars-title-content-active">（3）工作满一年且代课量符合一对一部平均代课水平，奖金1000元。</span>
                    <p>6. 注意事项</p>
                    <span class="spanClass labourParticulars-title-content-active">（1）“伯乐奖”奖金由人力资源部招聘专员发起申请并全程跟踪，经招聘经理审核、人力资源部总监、校长审批后下发。</span>
                    <span class="spanClass labourParticulars-title-content-active">（2）“伯乐奖”适用除以下人员之外的天津新东方学校所有教职员工：部门负责人（含副职）；部门负责招聘的工作人员、人力资源部总监；人力资源部招聘经理；人力资源部招聘相关的工作人员。</span>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        fn() {

        },
        getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "6"
                }
            })
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 20px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
    line-height: 23px
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Appendix/appendix5.vue